<div #searchControl class="input-auto-complete">
  <ipo-input-auto-complete
    [placeholder]="'searchComponent.placeholder' | translate"
    [options]="searchOptions"
    [icon]="'search'"
    [initialFocus]="true"
    (selected)="onSelectedSearchFeature($event)"
    (input)="onSearchFeature($event)"
    [showListOnFocus]="false"
    (click)="shouldClearResultControl($event)"
    (keydown.enter)="shouldClearResultControl($event)"
  ></ipo-input-auto-complete>
</div>

@if (selectedResultControl$ | async; as selectedResultControl) {
  <div #selectedResultControl>
    @if (selectedResultControl.name) {
      <section class="selected-result-control">
        <app-popup-content
          [properties]="selectedResultControl"
          [typeId]="selectedResultControl.typeId"
          [shouldShowCloseButton]="false"
          [clickedObject]="selectedResultControl.clickedObject"
          [expandedPointId]="selectedResultControl.expandedPointId"
        ></app-popup-content>
      </section>
    }
  </div>
}

<div #homeControl class="map-control-actions">
  <gc-button
    [variant]="'secondary'"
    [icon]="'house'"
    (click)="homeClicked.emit()"
    (keydown.enter)="homeClicked.emit()"
  />
</div>

<div #versionControl class="version-button">
  <gc-button
    [variant]="'strong'"
    [hidden]="!hasVersion()"
    (click)="onVersionClicked($event)"
  >
    {{ versionButtonText() }}
  </gc-button>
</div>

<div #locationControl class="map-control-actions">
  <gc-button
    [variant]="'secondary'"
    [icon]="'locationPin'"
    (click)="geolocationClicked.emit()"
    (keydown.enter)="geolocationClicked.emit()"
  />
</div>

<div #ordersControl class="map-control-actions">
  <gc-button
    [variant]="'secondary'"
    [size]="'full'"
    [icon]="'dashboard'"
    [iconSize]="'small'"
    (click)="openOrdersOverviewModal($event)"
    (keydown.enter)="openOrdersOverviewModal($event)"
  >
    @if (!isMobileScreen()) {
      <gc-text [variant]="'body'" class="button-text" class="text-margin">
        {{ 'orders' | translate }}
      </gc-text>
    }
  </gc-button>
</div>

<div #ductMenuControl class="map-control-actions">
  @if (activeSidePanel !== 'ducts') {
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      [icon]="'barsLeft'"
      [iconSize]="'small'"
      (click)="onDuctMenuClicked($event)"
      (keydown.enter)="onDuctMenuClicked($event)"
    >
      @if (!isMobileScreen()) {
        <gc-text [variant]="'body'" class="text-margin">
          {{ 'ducts' | translate }}
        </gc-text>
      }
    </gc-button>
  }
  @if (activeSidePanel === 'ducts') {
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      [icon]="'x'"
      [iconSize]="'small'"
      (click)="onDuctMenuClicked($event)"
      (keydown.enter)="onDuctMenuClicked($event)"
    >
      @if (!isMobileScreen()) {
        <gc-text [variant]="'body'" class="text-margin">
          {{ 'close' | translate }}
        </gc-text>
      }
    </gc-button>
  }
</div>

<div #reportsPanelControl class="map-control-actions">
  @if (activeSidePanel !== 'reports') {
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      [icon]="'barsLeft'"
      [iconSize]="'small'"
      (click)="onReportsPanelClicked($event)"
      (keydown.enter)="onReportsPanelClicked($event)"
    >
      @if (!isMobileScreen()) {
        <gc-text [variant]="'body'" class="text-margin">
          {{ 'reportsMenu' | translate }}
        </gc-text>
      }
    </gc-button>
  }
  @if (activeSidePanel === 'reports') {
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      [icon]="'x'"
      [iconSize]="'small'"
      (click)="onReportsPanelClicked($event)"
      (keydown.enter)="onReportsPanelClicked($event)"
    >
      @if (!isMobileScreen()) {
        <gc-text [variant]="'body'" class="text-margin">
          {{ 'close' | translate }}
        </gc-text>
      }
    </gc-button>
  }
</div>

<div #legendControl class="map-control-actions">
  @if (!legendToggled) {
    <gc-button
      [variant]="'secondary'"
      [icon]="'layers'"
      [iconSize]="'medium'"
      (click)="onLegendClicked($event)"
      (keydown.enter)="onLegendClicked($event)"
    />
  }
  <div [hidden]="!legendToggled">
    <div class="header">
      <gc-text [variant]="'paragraph'">{{
        'legend.legendLabel' | translate
      }}</gc-text>
      <gc-button
        [icon]="'x'"
        [variant]="'plain'"
        (clicked)="onLegendClicked($event)"
      />
    </div>

    <div class="map-control-action-content">
      @for (description of legendData; track description) {
        <div class="map-legend_group">
          <gc-text [variant]="'paragraphBold'"
            >{{ description.layerName | translate }}
          </gc-text>
          @for (item of description.legendItems; track item) {
            <div class="map-legend_item">
              @if (item.icon.color) {
                <div
                  class="item-color"
                  [style.border-color]="
                    description.type === 'marker' || description.type === 'line'
                      ? '#000'
                      : item.icon.color
                  "
                  [style.border-radius]="
                    description.type === 'marker'
                      ? calculatePointBorderRadius(item.icon)
                      : 0
                  "
                  [style.transform]="
                    description.type === 'marker' &&
                    calculatePointTransform(item.icon)
                  "
                  [style.border-width.px]="
                    item.icon.borderWidth ? item.icon.borderWidth : 1
                  "
                  [style.border-style]="
                    item.icon.style ? item.icon.style : 'solid'
                  "
                  [style.background-color]="
                    description.type === 'polygon'
                      ? addAlpha(item.icon.color!)
                      : item.icon.color
                  "
                  [style.height.px]="item.icon.size ? item.icon.size : 10"
                ></div>
              } @else {
                <div class="item-color img-div">
                  <img
                    class="img-icon"
                    [src]="
                      'assets/leaflet/images/point-icons/' +
                      item.icon.iconPath +
                      '.svg'
                    "
                    alt="Icon"
                  />
                </div>
              }
              <gc-text [variant]="'information'">
                {{ item.description | translate }}
              </gc-text>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<div #filterMenuControl class="map-control-actions">
  <div>
    @if (!filterOpened) {
      <gc-button
        [variant]="'secondary'"
        [icon]="'filter'"
        [iconSize]="'medium'"
        (clicked)="filterOpened = true"
      />
    }

    @if (filterOpened) {
      <div class="header">
        <gc-text [variant]="'paragraph'">{{
          'legend.filterLabel' | translate
        }}</gc-text>
        <gc-button
          [icon]="'x'"
          [variant]="'plain'"
          (clicked)="onFilterClicked($event)"
        />
      </div>
      <div class="map-control-action-content">
        <div class="map-control-filter">
          <gc-checkbox
            [label]="'legend.selectAll' | translate"
            [checked]="allOverlaysChecked()"
            (changed)="selectAllLayers($event)"
          />
          @for (entry of overlayEntries; track entry) {
            <gc-checkbox
              [label]="entry.key"
              [checked]="isLayerAdded(entry.layer)"
              (changed)="toggleLayer($event, entry.layer)"
            />
          }
        </div>
      </div>
    }
  </div>
</div>
